import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { floatBetween } from "html-living-framework/lib/Utils/Random";

export class Apple extends SceneDraggable {
    cancelSelectionWhenAnotherDragStarts = true;

    public drop() {
        super.drop();
        this.dragEnd();
    }

    dragEnd() {
        super.dragEnd();
        this.deselect();
        this.visuals.position.set(0);
        this.visuals.scale.set(1);
    }

    public Eat(pProgress: 0 | 0.5 | 1) {
        let newTexture: string;
        switch (pProgress) {
            case 0:
                newTexture = "apple_whole";
                break;
            case 0.5:
                newTexture = "apple_part_eaten";
                break;
            case 1:
                newTexture = "apple_eaten";
                break;
        }
        this.setLayoutTexture(newTexture, 0.5, 0.5);
    }

    onLayout() {
        this.scale.set(Math.max(this.scale.x, this.scale.y));
        this.Eat(0);
    }
}
